jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
	screensize: {
		getCurrentScreenSize: function () {
			const BREAKPOINT_M = 481;
			const BREAKPOINT_L = 768;
			const BREAKPOINT_XL = 980;
			const windowWidth = this.getInnerWidth();
			let screenSize;

			if (windowWidth >= 0 && windowWidth < BREAKPOINT_M) {
				screenSize = 'S';
			} else if (windowWidth >= BREAKPOINT_M && windowWidth < BREAKPOINT_L) {
				screenSize = 'M';
			} else if (windowWidth >= BREAKPOINT_L && windowWidth < BREAKPOINT_XL) {
				screenSize = 'L';
			} else if (windowWidth >= BREAKPOINT_XL) {
				screenSize = 'XL';
			}
			return screenSize;
		},

		isBreakpoint: function (breakpoints) {
			return breakpoints.indexOf(jPar.wdk.screensize.getCurrentScreenSize()) > -1;
		},

		getInnerWidth: function (forceFresh) {
			if (document.querySelector('peg-app-shell') === null || forceFresh) {
				return window.innerWidth;
			} else {
				return document.querySelector('peg-app-shell').getCachedWindowWidth();
			}
		},

		/**
		 * Für SCRUM-14941: Single Product Paywall for Screensize S/M
		 */
		setScreenSizeCookie: function () {
			try {
				//TODO if supported in Safari 17. We have a shim here
				window.requestIdleCallback(() => {
					const currentScreenSize = this.getCurrentScreenSize();
					setCookie('currentScreenSize', currentScreenSize);
					if ($j('#specialOfferScreensize').length > 0) {
						$j('#specialOfferScreensize').val(currentScreenSize);
					}
				});
			} catch (e) {
				jPar.util.log.error(
					'failed to set screensize-cookie on page ' + $j('body').attr('id') + ' - ' + e,
					'jPar.wdk.screensize.setScreenSizeCookie()',
				);
			}
		},
	},
});
